import React, { createContext, useContext, useState } from 'react';

export type ChartGuideListStyle = 'bullet' | 'decimal' | 'none';

export interface ChartGuideSection {
  title: string;
  style?: ChartGuideListStyle;
  items: string[];
}

export interface ChartGuide {
  title: string;
  description: string;
  interpretation: string;
  tips?: string[];
  sections?: ChartGuideSection[];
}

interface ChartGuideContextType {
  isModalOpen: boolean;
  currentGuide: ChartGuide | null;
  openGuide: (guide: ChartGuide) => void;
  closeGuide: () => void;
}

const ChartGuideContext = createContext<ChartGuideContextType | undefined>(undefined);

export const ChartGuideProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentGuide, setCurrentGuide] = useState<ChartGuide | null>(null);

  const openGuide = (guide: ChartGuide) => {
    setCurrentGuide(guide);
    setIsModalOpen(true);
  };

  const closeGuide = () => {
    setIsModalOpen(false);
    setTimeout(() => setCurrentGuide(null), 300);
  };

  return (
    <ChartGuideContext.Provider value={{ isModalOpen, currentGuide, openGuide, closeGuide }}>
      {children}
    </ChartGuideContext.Provider>
  );
};

export const useChartGuide = () => {
  const context = useContext(ChartGuideContext);
  if (!context) {
    throw new Error('useChartGuide must be used within a ChartGuideProvider');
  }
  return context;
};